import { KeyOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Flex, message } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  userAPIWithErrorHandling,
  userShopHelpers,
} from "../../../api/User/infoUser";
import BrandedPageLayout from "../../../components/Dashboard/BrandedPageLayout";
import ListTableCard from "../../../components/common/ListTableCard";
import { actionColumnDef } from "../../../components/common/RowActions";
import ListToolbar, {
  selectVisibleColumns,
  useListToolbar,
} from "../../../components/common/ListToolbar";

const DEFAULT_VISIBLE_FILTERS = [];
const DEFAULT_VISIBLE_COLUMNS = ["username", "phone", "email"];

export default function ListAccout() {
  const navigate = useNavigate();

  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    from: 0,
    to: 0,
    lastPage: 1,
  });

  const {
    visibleFilters, setVisibleFilters,
    visibleColumns, setVisibleColumns,
  } = useListToolbar({
    defaultVisibleFilters: DEFAULT_VISIBLE_FILTERS,
    defaultVisibleColumns: DEFAULT_VISIBLE_COLUMNS,
  });

  const fetchData = async (page = 1, perPage = 10, search = "") => {
    setLoading(true);
    try {
      const params = {
        page,
        per_page: perPage,
        search: search.trim(),
      };

      const response = await userAPIWithErrorHandling.getUserShops(params);
      const { userShops: customerData, pagination: paginationData } =
        userShopHelpers.extractUserShopList(response);

      setShops(customerData);
      setPagination({
        current: paginationData.current,
        pageSize: paginationData.pageSize,
        total: paginationData.total,
        from: paginationData.from,
        to: paginationData.to,
        lastPage: paginationData.lastPage,
      });
    } catch (error) {
      message.error(error.message || "Không thể tải danh sách khách hàng");
      console.error("Error fetching customers:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTableChange = (paginationConfig) => {
    fetchData(paginationConfig.current, paginationConfig.pageSize);
  };

  // ===== Định nghĩa cột =====
  const columnDefs = [
    {
      key: "id", label: "ID", fixed: true,
      column: { title: "ID", dataIndex: "id", key: "id" },
    },
    {
      key: "username", label: "Tên",
      column: {
        title: "Tên", dataIndex: "username", key: "username", editable: true,
        render: (text, record) => {
          const userAvatar = record?.avatar
            ? `${process.env.REACT_APP_API_URL}/${record.avatar}`
            : null;
          return (
            <Flex align="center">
              <Avatar
                style={{ cursor: "pointer", marginRight: "12px" }}
                size={40}
                src={userAvatar}
                icon={record?.avatar ? null : <UserOutlined />}
              />
              <span>{text}</span>
            </Flex>
          );
        },
      },
    },
    {
      key: "phone", label: "Số điện thoại",
      column: { title: "Số điện thoại", dataIndex: "phone", key: "phone" },
    },
    {
      key: "email", label: "Email",
      column: { title: "Email", dataIndex: "email", key: "email" },
    },
    actionColumnDef(
      (record) => [
        {
          key: "permission", label: "Thêm quyền", icon: <KeyOutlined />, tone: "success",
          onClick: () => navigate(`/add-permission/${record.id}`),
        },
      ],
      { width: 80 }
    ),
  ];

  const filterDefs = [];

  const columns = selectVisibleColumns(columnDefs, visibleColumns);

  return (
    <BrandedPageLayout
      title="Tài khoản"
      subtitle="Quản lý tài khoản chủ đơn vị."
      breadcrumbItems={[{ title: "Tài khoản" }]}
    >
      <ListToolbar
        filterDefs={filterDefs}
        visibleFilters={visibleFilters}
        onChangeVisibleFilters={setVisibleFilters}
        columnDefs={columnDefs}
        visibleColumns={visibleColumns}
        onChangeVisibleColumns={setVisibleColumns}
        defaultVisibleColumns={DEFAULT_VISIBLE_COLUMNS}
        hasActiveFilter={false}
        onReload={() => fetchData(pagination.current, pagination.pageSize)}
      />

      <ListTableCard
        columns={columns}
        dataSource={shops}
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
        }}
        onChange={handleTableChange}
        emptyText="Không có dữ liệu"
      />
    </BrandedPageLayout>
  );
}
